/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiProjectChangeOrderApproveProjectChangeOrderPost } from '../fn/project-change-orders/api-project-change-order-approve-project-change-order-post';
import { ApiProjectChangeOrderApproveProjectChangeOrderPost$Params } from '../fn/project-change-orders/api-project-change-order-approve-project-change-order-post';
import { apiProjectChangeOrderApproveProjectChangeOrderPost$Plain } from '../fn/project-change-orders/api-project-change-order-approve-project-change-order-post-plain';
import { ApiProjectChangeOrderApproveProjectChangeOrderPost$Plain$Params } from '../fn/project-change-orders/api-project-change-order-approve-project-change-order-post-plain';
import { apiProjectChangeOrderCreateProjectChangeOrderDetailsPost } from '../fn/project-change-orders/api-project-change-order-create-project-change-order-details-post';
import { ApiProjectChangeOrderCreateProjectChangeOrderDetailsPost$Params } from '../fn/project-change-orders/api-project-change-order-create-project-change-order-details-post';
import { apiProjectChangeOrderCreateProjectChangeOrderDetailsPost$Plain } from '../fn/project-change-orders/api-project-change-order-create-project-change-order-details-post-plain';
import { ApiProjectChangeOrderCreateProjectChangeOrderDetailsPost$Plain$Params } from '../fn/project-change-orders/api-project-change-order-create-project-change-order-details-post-plain';
import { apiProjectChangeOrderCreateProjectChangeOrderPost } from '../fn/project-change-orders/api-project-change-order-create-project-change-order-post';
import { ApiProjectChangeOrderCreateProjectChangeOrderPost$Params } from '../fn/project-change-orders/api-project-change-order-create-project-change-order-post';
import { apiProjectChangeOrderCreateProjectChangeOrderPost$Plain } from '../fn/project-change-orders/api-project-change-order-create-project-change-order-post-plain';
import { ApiProjectChangeOrderCreateProjectChangeOrderPost$Plain$Params } from '../fn/project-change-orders/api-project-change-order-create-project-change-order-post-plain';
import { apiProjectChangeOrderDeleteProjectChangeOrderDelete } from '../fn/project-change-orders/api-project-change-order-delete-project-change-order-delete';
import { ApiProjectChangeOrderDeleteProjectChangeOrderDelete$Params } from '../fn/project-change-orders/api-project-change-order-delete-project-change-order-delete';
import { apiProjectChangeOrderDeleteProjectChangeOrderDelete$Plain } from '../fn/project-change-orders/api-project-change-order-delete-project-change-order-delete-plain';
import { ApiProjectChangeOrderDeleteProjectChangeOrderDelete$Plain$Params } from '../fn/project-change-orders/api-project-change-order-delete-project-change-order-delete-plain';
import { apiProjectChangeOrderDeleteProjectChangeOrderDetailsDelete } from '../fn/project-change-orders/api-project-change-order-delete-project-change-order-details-delete';
import { ApiProjectChangeOrderDeleteProjectChangeOrderDetailsDelete$Params } from '../fn/project-change-orders/api-project-change-order-delete-project-change-order-details-delete';
import { apiProjectChangeOrderDeleteProjectChangeOrderDetailsDelete$Plain } from '../fn/project-change-orders/api-project-change-order-delete-project-change-order-details-delete-plain';
import { ApiProjectChangeOrderDeleteProjectChangeOrderDetailsDelete$Plain$Params } from '../fn/project-change-orders/api-project-change-order-delete-project-change-order-details-delete-plain';
import { apiProjectChangeOrderGetProjectChangeOrderByIdPost } from '../fn/project-change-orders/api-project-change-order-get-project-change-order-by-id-post';
import { ApiProjectChangeOrderGetProjectChangeOrderByIdPost$Params } from '../fn/project-change-orders/api-project-change-order-get-project-change-order-by-id-post';
import { apiProjectChangeOrderGetProjectChangeOrderByIdPost$Plain } from '../fn/project-change-orders/api-project-change-order-get-project-change-order-by-id-post-plain';
import { ApiProjectChangeOrderGetProjectChangeOrderByIdPost$Plain$Params } from '../fn/project-change-orders/api-project-change-order-get-project-change-order-by-id-post-plain';
import { apiProjectChangeOrderGetProjectChangeOrderPost } from '../fn/project-change-orders/api-project-change-order-get-project-change-order-post';
import { ApiProjectChangeOrderGetProjectChangeOrderPost$Params } from '../fn/project-change-orders/api-project-change-order-get-project-change-order-post';
import { apiProjectChangeOrderGetProjectChangeOrderPost$Plain } from '../fn/project-change-orders/api-project-change-order-get-project-change-order-post-plain';
import { ApiProjectChangeOrderGetProjectChangeOrderPost$Plain$Params } from '../fn/project-change-orders/api-project-change-order-get-project-change-order-post-plain';
import { apiProjectChangeOrderGetProjectChangeOrdersDetailsPost } from '../fn/project-change-orders/api-project-change-order-get-project-change-orders-details-post';
import { ApiProjectChangeOrderGetProjectChangeOrdersDetailsPost$Params } from '../fn/project-change-orders/api-project-change-order-get-project-change-orders-details-post';
import { apiProjectChangeOrderGetProjectChangeOrdersDetailsPost$Plain } from '../fn/project-change-orders/api-project-change-order-get-project-change-orders-details-post-plain';
import { ApiProjectChangeOrderGetProjectChangeOrdersDetailsPost$Plain$Params } from '../fn/project-change-orders/api-project-change-order-get-project-change-orders-details-post-plain';
import { apiProjectChangeOrderUpdateProjectChangeOrderDetailsPatch } from '../fn/project-change-orders/api-project-change-order-update-project-change-order-details-patch';
import { ApiProjectChangeOrderUpdateProjectChangeOrderDetailsPatch$Params } from '../fn/project-change-orders/api-project-change-order-update-project-change-order-details-patch';
import { apiProjectChangeOrderUpdateProjectChangeOrderDetailsPatch$Plain } from '../fn/project-change-orders/api-project-change-order-update-project-change-order-details-patch-plain';
import { ApiProjectChangeOrderUpdateProjectChangeOrderDetailsPatch$Plain$Params } from '../fn/project-change-orders/api-project-change-order-update-project-change-order-details-patch-plain';
import { apiProjectChangeOrderUpdateProjectChangeOrderPatch } from '../fn/project-change-orders/api-project-change-order-update-project-change-order-patch';
import { ApiProjectChangeOrderUpdateProjectChangeOrderPatch$Params } from '../fn/project-change-orders/api-project-change-order-update-project-change-order-patch';
import { apiProjectChangeOrderUpdateProjectChangeOrderPatch$Plain } from '../fn/project-change-orders/api-project-change-order-update-project-change-order-patch-plain';
import { ApiProjectChangeOrderUpdateProjectChangeOrderPatch$Plain$Params } from '../fn/project-change-orders/api-project-change-order-update-project-change-order-patch-plain';
import { ApproveProjectChangeOrderCommandResult } from '../models/approve-project-change-order-command-result';
import { CreateProjectChangeOrderCommandResult } from '../models/create-project-change-order-command-result';
import { CreateProjectChangeOrderDetailsCommandResult } from '../models/create-project-change-order-details-command-result';
import { DeleteProjectChangeOrderCommandResult } from '../models/delete-project-change-order-command-result';
import { DeleteProjectChangeOrderDetailsCommandResult } from '../models/delete-project-change-order-details-command-result';
import { GetProjectChangeOrderByIdQueryResult } from '../models/get-project-change-order-by-id-query-result';
import { GetProjectChangeOrderQueryResult } from '../models/get-project-change-order-query-result';
import { GetProjectChangeOrdersDetailsQueryResult } from '../models/get-project-change-orders-details-query-result';
import { UpdateProjectChangeOrderCommandResult } from '../models/update-project-change-order-command-result';
import { UpdateProjectChangeOrderDetailsCommandResult } from '../models/update-project-change-order-details-command-result';

@Injectable({ providedIn: 'root' })
export class ProjectChangeOrdersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiProjectChangeOrderGetProjectChangeOrderPost()` */
  static readonly ApiProjectChangeOrderGetProjectChangeOrderPostPath = '/api/ProjectChangeOrder/GetProjectChangeOrder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectChangeOrderGetProjectChangeOrderPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderGetProjectChangeOrderPost$Plain$Response(params?: ApiProjectChangeOrderGetProjectChangeOrderPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectChangeOrderQueryResult>> {
    return apiProjectChangeOrderGetProjectChangeOrderPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectChangeOrderGetProjectChangeOrderPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderGetProjectChangeOrderPost$Plain(params?: ApiProjectChangeOrderGetProjectChangeOrderPost$Plain$Params, context?: HttpContext): Observable<GetProjectChangeOrderQueryResult> {
    return this.apiProjectChangeOrderGetProjectChangeOrderPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectChangeOrderQueryResult>): GetProjectChangeOrderQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectChangeOrderGetProjectChangeOrderPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderGetProjectChangeOrderPost$Response(params?: ApiProjectChangeOrderGetProjectChangeOrderPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectChangeOrderQueryResult>> {
    return apiProjectChangeOrderGetProjectChangeOrderPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectChangeOrderGetProjectChangeOrderPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderGetProjectChangeOrderPost(params?: ApiProjectChangeOrderGetProjectChangeOrderPost$Params, context?: HttpContext): Observable<GetProjectChangeOrderQueryResult> {
    return this.apiProjectChangeOrderGetProjectChangeOrderPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectChangeOrderQueryResult>): GetProjectChangeOrderQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectChangeOrderCreateProjectChangeOrderPost()` */
  static readonly ApiProjectChangeOrderCreateProjectChangeOrderPostPath = '/api/ProjectChangeOrder/CreateProjectChangeOrder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectChangeOrderCreateProjectChangeOrderPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectChangeOrderCreateProjectChangeOrderPost$Plain$Response(params?: ApiProjectChangeOrderCreateProjectChangeOrderPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectChangeOrderCommandResult>> {
    return apiProjectChangeOrderCreateProjectChangeOrderPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectChangeOrderCreateProjectChangeOrderPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectChangeOrderCreateProjectChangeOrderPost$Plain(params?: ApiProjectChangeOrderCreateProjectChangeOrderPost$Plain$Params, context?: HttpContext): Observable<CreateProjectChangeOrderCommandResult> {
    return this.apiProjectChangeOrderCreateProjectChangeOrderPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectChangeOrderCommandResult>): CreateProjectChangeOrderCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectChangeOrderCreateProjectChangeOrderPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectChangeOrderCreateProjectChangeOrderPost$Response(params?: ApiProjectChangeOrderCreateProjectChangeOrderPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectChangeOrderCommandResult>> {
    return apiProjectChangeOrderCreateProjectChangeOrderPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectChangeOrderCreateProjectChangeOrderPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectChangeOrderCreateProjectChangeOrderPost(params?: ApiProjectChangeOrderCreateProjectChangeOrderPost$Params, context?: HttpContext): Observable<CreateProjectChangeOrderCommandResult> {
    return this.apiProjectChangeOrderCreateProjectChangeOrderPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectChangeOrderCommandResult>): CreateProjectChangeOrderCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectChangeOrderApproveProjectChangeOrderPost()` */
  static readonly ApiProjectChangeOrderApproveProjectChangeOrderPostPath = '/api/ProjectChangeOrder/ApproveProjectChangeOrder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectChangeOrderApproveProjectChangeOrderPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectChangeOrderApproveProjectChangeOrderPost$Plain$Response(params?: ApiProjectChangeOrderApproveProjectChangeOrderPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ApproveProjectChangeOrderCommandResult>> {
    return apiProjectChangeOrderApproveProjectChangeOrderPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectChangeOrderApproveProjectChangeOrderPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectChangeOrderApproveProjectChangeOrderPost$Plain(params?: ApiProjectChangeOrderApproveProjectChangeOrderPost$Plain$Params, context?: HttpContext): Observable<ApproveProjectChangeOrderCommandResult> {
    return this.apiProjectChangeOrderApproveProjectChangeOrderPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApproveProjectChangeOrderCommandResult>): ApproveProjectChangeOrderCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectChangeOrderApproveProjectChangeOrderPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectChangeOrderApproveProjectChangeOrderPost$Response(params?: ApiProjectChangeOrderApproveProjectChangeOrderPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ApproveProjectChangeOrderCommandResult>> {
    return apiProjectChangeOrderApproveProjectChangeOrderPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectChangeOrderApproveProjectChangeOrderPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectChangeOrderApproveProjectChangeOrderPost(params?: ApiProjectChangeOrderApproveProjectChangeOrderPost$Params, context?: HttpContext): Observable<ApproveProjectChangeOrderCommandResult> {
    return this.apiProjectChangeOrderApproveProjectChangeOrderPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApproveProjectChangeOrderCommandResult>): ApproveProjectChangeOrderCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectChangeOrderUpdateProjectChangeOrderPatch()` */
  static readonly ApiProjectChangeOrderUpdateProjectChangeOrderPatchPath = '/api/ProjectChangeOrder/UpdateProjectChangeOrder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectChangeOrderUpdateProjectChangeOrderPatch$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectChangeOrderUpdateProjectChangeOrderPatch$Plain$Response(params?: ApiProjectChangeOrderUpdateProjectChangeOrderPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectChangeOrderCommandResult>> {
    return apiProjectChangeOrderUpdateProjectChangeOrderPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectChangeOrderUpdateProjectChangeOrderPatch$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectChangeOrderUpdateProjectChangeOrderPatch$Plain(params?: ApiProjectChangeOrderUpdateProjectChangeOrderPatch$Plain$Params, context?: HttpContext): Observable<UpdateProjectChangeOrderCommandResult> {
    return this.apiProjectChangeOrderUpdateProjectChangeOrderPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectChangeOrderCommandResult>): UpdateProjectChangeOrderCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectChangeOrderUpdateProjectChangeOrderPatch()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectChangeOrderUpdateProjectChangeOrderPatch$Response(params?: ApiProjectChangeOrderUpdateProjectChangeOrderPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectChangeOrderCommandResult>> {
    return apiProjectChangeOrderUpdateProjectChangeOrderPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectChangeOrderUpdateProjectChangeOrderPatch$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectChangeOrderUpdateProjectChangeOrderPatch(params?: ApiProjectChangeOrderUpdateProjectChangeOrderPatch$Params, context?: HttpContext): Observable<UpdateProjectChangeOrderCommandResult> {
    return this.apiProjectChangeOrderUpdateProjectChangeOrderPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectChangeOrderCommandResult>): UpdateProjectChangeOrderCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectChangeOrderDeleteProjectChangeOrderDelete()` */
  static readonly ApiProjectChangeOrderDeleteProjectChangeOrderDeletePath = '/api/ProjectChangeOrder/DeleteProjectChangeOrder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectChangeOrderDeleteProjectChangeOrderDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderDeleteProjectChangeOrderDelete$Plain$Response(params?: ApiProjectChangeOrderDeleteProjectChangeOrderDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectChangeOrderCommandResult>> {
    return apiProjectChangeOrderDeleteProjectChangeOrderDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectChangeOrderDeleteProjectChangeOrderDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderDeleteProjectChangeOrderDelete$Plain(params?: ApiProjectChangeOrderDeleteProjectChangeOrderDelete$Plain$Params, context?: HttpContext): Observable<DeleteProjectChangeOrderCommandResult> {
    return this.apiProjectChangeOrderDeleteProjectChangeOrderDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectChangeOrderCommandResult>): DeleteProjectChangeOrderCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectChangeOrderDeleteProjectChangeOrderDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderDeleteProjectChangeOrderDelete$Response(params?: ApiProjectChangeOrderDeleteProjectChangeOrderDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectChangeOrderCommandResult>> {
    return apiProjectChangeOrderDeleteProjectChangeOrderDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectChangeOrderDeleteProjectChangeOrderDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderDeleteProjectChangeOrderDelete(params?: ApiProjectChangeOrderDeleteProjectChangeOrderDelete$Params, context?: HttpContext): Observable<DeleteProjectChangeOrderCommandResult> {
    return this.apiProjectChangeOrderDeleteProjectChangeOrderDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectChangeOrderCommandResult>): DeleteProjectChangeOrderCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectChangeOrderGetProjectChangeOrdersDetailsPost()` */
  static readonly ApiProjectChangeOrderGetProjectChangeOrdersDetailsPostPath = '/api/ProjectChangeOrder/GetProjectChangeOrdersDetails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectChangeOrderGetProjectChangeOrdersDetailsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderGetProjectChangeOrdersDetailsPost$Plain$Response(params?: ApiProjectChangeOrderGetProjectChangeOrdersDetailsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectChangeOrdersDetailsQueryResult>> {
    return apiProjectChangeOrderGetProjectChangeOrdersDetailsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectChangeOrderGetProjectChangeOrdersDetailsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderGetProjectChangeOrdersDetailsPost$Plain(params?: ApiProjectChangeOrderGetProjectChangeOrdersDetailsPost$Plain$Params, context?: HttpContext): Observable<GetProjectChangeOrdersDetailsQueryResult> {
    return this.apiProjectChangeOrderGetProjectChangeOrdersDetailsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectChangeOrdersDetailsQueryResult>): GetProjectChangeOrdersDetailsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectChangeOrderGetProjectChangeOrdersDetailsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderGetProjectChangeOrdersDetailsPost$Response(params?: ApiProjectChangeOrderGetProjectChangeOrdersDetailsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectChangeOrdersDetailsQueryResult>> {
    return apiProjectChangeOrderGetProjectChangeOrdersDetailsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectChangeOrderGetProjectChangeOrdersDetailsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderGetProjectChangeOrdersDetailsPost(params?: ApiProjectChangeOrderGetProjectChangeOrdersDetailsPost$Params, context?: HttpContext): Observable<GetProjectChangeOrdersDetailsQueryResult> {
    return this.apiProjectChangeOrderGetProjectChangeOrdersDetailsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectChangeOrdersDetailsQueryResult>): GetProjectChangeOrdersDetailsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectChangeOrderGetProjectChangeOrderByIdPost()` */
  static readonly ApiProjectChangeOrderGetProjectChangeOrderByIdPostPath = '/api/ProjectChangeOrder/GetProjectChangeOrderById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectChangeOrderGetProjectChangeOrderByIdPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderGetProjectChangeOrderByIdPost$Plain$Response(params?: ApiProjectChangeOrderGetProjectChangeOrderByIdPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectChangeOrderByIdQueryResult>> {
    return apiProjectChangeOrderGetProjectChangeOrderByIdPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectChangeOrderGetProjectChangeOrderByIdPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderGetProjectChangeOrderByIdPost$Plain(params?: ApiProjectChangeOrderGetProjectChangeOrderByIdPost$Plain$Params, context?: HttpContext): Observable<GetProjectChangeOrderByIdQueryResult> {
    return this.apiProjectChangeOrderGetProjectChangeOrderByIdPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectChangeOrderByIdQueryResult>): GetProjectChangeOrderByIdQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectChangeOrderGetProjectChangeOrderByIdPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderGetProjectChangeOrderByIdPost$Response(params?: ApiProjectChangeOrderGetProjectChangeOrderByIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectChangeOrderByIdQueryResult>> {
    return apiProjectChangeOrderGetProjectChangeOrderByIdPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectChangeOrderGetProjectChangeOrderByIdPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderGetProjectChangeOrderByIdPost(params?: ApiProjectChangeOrderGetProjectChangeOrderByIdPost$Params, context?: HttpContext): Observable<GetProjectChangeOrderByIdQueryResult> {
    return this.apiProjectChangeOrderGetProjectChangeOrderByIdPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectChangeOrderByIdQueryResult>): GetProjectChangeOrderByIdQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectChangeOrderCreateProjectChangeOrderDetailsPost()` */
  static readonly ApiProjectChangeOrderCreateProjectChangeOrderDetailsPostPath = '/api/ProjectChangeOrder/CreateProjectChangeOrderDetails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectChangeOrderCreateProjectChangeOrderDetailsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderCreateProjectChangeOrderDetailsPost$Plain$Response(params?: ApiProjectChangeOrderCreateProjectChangeOrderDetailsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectChangeOrderDetailsCommandResult>> {
    return apiProjectChangeOrderCreateProjectChangeOrderDetailsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectChangeOrderCreateProjectChangeOrderDetailsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderCreateProjectChangeOrderDetailsPost$Plain(params?: ApiProjectChangeOrderCreateProjectChangeOrderDetailsPost$Plain$Params, context?: HttpContext): Observable<CreateProjectChangeOrderDetailsCommandResult> {
    return this.apiProjectChangeOrderCreateProjectChangeOrderDetailsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectChangeOrderDetailsCommandResult>): CreateProjectChangeOrderDetailsCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectChangeOrderCreateProjectChangeOrderDetailsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderCreateProjectChangeOrderDetailsPost$Response(params?: ApiProjectChangeOrderCreateProjectChangeOrderDetailsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectChangeOrderDetailsCommandResult>> {
    return apiProjectChangeOrderCreateProjectChangeOrderDetailsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectChangeOrderCreateProjectChangeOrderDetailsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderCreateProjectChangeOrderDetailsPost(params?: ApiProjectChangeOrderCreateProjectChangeOrderDetailsPost$Params, context?: HttpContext): Observable<CreateProjectChangeOrderDetailsCommandResult> {
    return this.apiProjectChangeOrderCreateProjectChangeOrderDetailsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectChangeOrderDetailsCommandResult>): CreateProjectChangeOrderDetailsCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectChangeOrderUpdateProjectChangeOrderDetailsPatch()` */
  static readonly ApiProjectChangeOrderUpdateProjectChangeOrderDetailsPatchPath = '/api/ProjectChangeOrder/UpdateProjectChangeOrderDetails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectChangeOrderUpdateProjectChangeOrderDetailsPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderUpdateProjectChangeOrderDetailsPatch$Plain$Response(params?: ApiProjectChangeOrderUpdateProjectChangeOrderDetailsPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectChangeOrderDetailsCommandResult>> {
    return apiProjectChangeOrderUpdateProjectChangeOrderDetailsPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectChangeOrderUpdateProjectChangeOrderDetailsPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderUpdateProjectChangeOrderDetailsPatch$Plain(params?: ApiProjectChangeOrderUpdateProjectChangeOrderDetailsPatch$Plain$Params, context?: HttpContext): Observable<UpdateProjectChangeOrderDetailsCommandResult> {
    return this.apiProjectChangeOrderUpdateProjectChangeOrderDetailsPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectChangeOrderDetailsCommandResult>): UpdateProjectChangeOrderDetailsCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectChangeOrderUpdateProjectChangeOrderDetailsPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderUpdateProjectChangeOrderDetailsPatch$Response(params?: ApiProjectChangeOrderUpdateProjectChangeOrderDetailsPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectChangeOrderDetailsCommandResult>> {
    return apiProjectChangeOrderUpdateProjectChangeOrderDetailsPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectChangeOrderUpdateProjectChangeOrderDetailsPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderUpdateProjectChangeOrderDetailsPatch(params?: ApiProjectChangeOrderUpdateProjectChangeOrderDetailsPatch$Params, context?: HttpContext): Observable<UpdateProjectChangeOrderDetailsCommandResult> {
    return this.apiProjectChangeOrderUpdateProjectChangeOrderDetailsPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectChangeOrderDetailsCommandResult>): UpdateProjectChangeOrderDetailsCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectChangeOrderDeleteProjectChangeOrderDetailsDelete()` */
  static readonly ApiProjectChangeOrderDeleteProjectChangeOrderDetailsDeletePath = '/api/ProjectChangeOrder/DeleteProjectChangeOrderDetails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectChangeOrderDeleteProjectChangeOrderDetailsDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderDeleteProjectChangeOrderDetailsDelete$Plain$Response(params?: ApiProjectChangeOrderDeleteProjectChangeOrderDetailsDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectChangeOrderDetailsCommandResult>> {
    return apiProjectChangeOrderDeleteProjectChangeOrderDetailsDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectChangeOrderDeleteProjectChangeOrderDetailsDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderDeleteProjectChangeOrderDetailsDelete$Plain(params?: ApiProjectChangeOrderDeleteProjectChangeOrderDetailsDelete$Plain$Params, context?: HttpContext): Observable<DeleteProjectChangeOrderDetailsCommandResult> {
    return this.apiProjectChangeOrderDeleteProjectChangeOrderDetailsDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectChangeOrderDetailsCommandResult>): DeleteProjectChangeOrderDetailsCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectChangeOrderDeleteProjectChangeOrderDetailsDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderDeleteProjectChangeOrderDetailsDelete$Response(params?: ApiProjectChangeOrderDeleteProjectChangeOrderDetailsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectChangeOrderDetailsCommandResult>> {
    return apiProjectChangeOrderDeleteProjectChangeOrderDetailsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectChangeOrderDeleteProjectChangeOrderDetailsDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectChangeOrderDeleteProjectChangeOrderDetailsDelete(params?: ApiProjectChangeOrderDeleteProjectChangeOrderDetailsDelete$Params, context?: HttpContext): Observable<DeleteProjectChangeOrderDetailsCommandResult> {
    return this.apiProjectChangeOrderDeleteProjectChangeOrderDetailsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectChangeOrderDetailsCommandResult>): DeleteProjectChangeOrderDetailsCommandResult => r.body)
    );
  }

}
